/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Animate free shipping progress bar from 0 to its rendered value after AJAX cart refresh
  function animateFreeShippingBar(container) {
    var bar = container.querySelector("[data-progress-bar]");
    if (!bar) return;
    var target = parseFloat(bar.value) || 0;
    bar.value = 0;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.value = target;
      });
    });
  }

  function initFreeShippingBarObserver() {
    var itemsHolder = document.querySelector("[data-items-holder]");
    if (!itemsHolder) return;

    animateFreeShippingBar(itemsHolder);

    new MutationObserver(function () {
      animateFreeShippingBar(itemsHolder);
    }).observe(itemsHolder, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFreeShippingBarObserver);
  } else {
    initFreeShippingBarObserver();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
